import React from "react";

const Image = () => (
  <svg width="308" height="390" viewBox="0 0 308 390">
    <g fill="none" fillRule="evenodd">
      <path fill="#FE9840" d="M129.16 270.82h19.34v-64.85h-19.34z" />
      <path
        d="M143.2 241.45h-8.74M143.2 265.23h-8.74M143.2 235.85h-8.74M143.2 230.24h-8.74"
        stroke="#FEC391"
        strokeWidth="2"
      />
      <path fill="#FE9840" d="M45.03 61.3h95.25V41.98H45.03z" />
      <path
        d="M88.16 56v-8.73M53.23 56v-8.73M96.4 56v-8.73M104.63 56v-8.73"
        stroke="#FEC391"
        strokeWidth="2"
      />
      <path fill="#23C991" d="M9.37 212.93l18-3.67L39 266.27l-18 3.67z" />
      <path fill="#86E0C2" d="M17.74 231.92l8.57-1.74 5.79 28.41-8.57 1.75z" />
      <path fill="#23C991" d="M158.78 238.99h99.63V220.6h-99.63z" />
      <path fill="#86E0C2" d="M193.5 234.56h49.67v-8.74h-49.66z" />
      <path fill="#23C991" d="M98.78 185.4h18.38v-68.42H98.78z" />
      <path fill="#86E0C2" d="M103.2 174.94h8.74v-34.11h-8.74z" />
      <path fill="#00A7DB" d="M41.3 185.4h20.47V94.52H41.3z" />
      <path d="M49.83 103.98h11.93" stroke="#75CFEC" strokeWidth="2" />
      <path fill="#75CFEC" d="M47.27 157.89h8.52v-35.86h-8.52z" />
      <path fill="#00A7DB" d="M201.73 378.47h20.47v-82.29h-20.47z" />
      <path d="M213.67 369.9h-11.94" stroke="#75CFEC" strokeWidth="2" />
      <path fill="#75CFEC" d="M207.7 353.55h8.53V321.1h-8.53z" />
      <path
        fill="#00A7DB"
        d="M70.89 263.11l-12.07 6.41-29.8-56.09 12.06-6.4z"
      />
      <path
        d="M57.14 258.63l5.66-3.01M59.31 262.72l5.67-3.01"
        stroke="#75CFEC"
        strokeWidth="2"
      />
      <path fill="#75CFEC" d="M41.55 229.3l5.67-3.01 12.88 24.23-5.67 3.01z" />
      <path fill="#00A7DB" d="M265.53 269.81h15.34v-64.18h-15.34z" />
      <path
        d="M276.8 216.15h-7.2M276.8 211.47h-7.2"
        stroke="#75CFEC"
        strokeWidth="2"
      />
      <path fill="#75CFEC" d="M269.6 249.71h7.2v-27.73h-7.2z" />
      <path fill="#00A7DB" d="M66.2 185.4h27.66v-64.18H66.2z" />
      <path
        d="M86.53 131.74h-13M86.53 127.06h-13"
        stroke="#75CFEC"
        strokeWidth="2"
      />
      <path fill="#75CFEC" d="M73.53 165.3h13v-27.73h-13z" />
      <path fill="#23C991" d="M11.58 378.98H33.7v-79.3H11.58z" />
      <path
        d="M11.58 307.47H25.4M15.73 359.15h13.83M15.73 366.77h13.83"
        stroke="#86E0C2"
        strokeWidth="2"
      />
      <path fill="#23C991" d="M24.82 76.56H133.3V61.6H24.82z" />
      <path
        d="M122.63 61.6v9.35M51.94 64.4v9.35M41.53 64.4v9.35"
        stroke="#86E0C2"
        strokeWidth="2"
      />
      <path fill="#23C991" d="M284.05 269.81h11.63v-56.56h-11.63z" />
      <path
        d="M295.68 264.26h-7.27M293.5 227.39h-7.27M293.5 221.96h-7.27"
        stroke="#86E0C2"
        strokeWidth="2"
      />
      <path fill="#23C991" d="M182.2 378.31h15.84v-74.46H182.2z" />
      <path
        d="M182.2 311.16h9.9M185.17 359.7h9.9M185.17 366.84h9.9"
        stroke="#86E0C2"
        strokeWidth="2"
      />
      <path fill="#FE9840" d="M58.14 378.98h29.05v-73.63H58.14z" />
      <path
        d="M63.67 338.15h17.98M63.67 312.66h17.98M63.67 345.76h17.98"
        stroke="#FEC391"
        strokeWidth="2"
      />
      <path
        fill="#FE9840"
        d="M264.76 379.4l-10.94-1.67 10.8-70.44 10.94 1.67z"
      />
      <path
        d="M262.73 339.64l4.94.76M266.69 313.81l4.94.76M261.8 345.73l4.94.76M260.86 351.82l4.94.76"
        stroke="#FEC391"
        strokeWidth="2"
      />
      <path fill="#00A7DB" d="M37.96 378.98h16.6v-84.96h-16.6z" />
      <path d="M44.88 302.87h9.68" stroke="#75CFEC" strokeWidth="2" />
      <path fill="#75CFEC" d="M42.8 353.25h6.92v-33.5h-6.91z" />
      <path fill="#23C991" d="M278.03 378.98h17.98v-73.63h-17.98z" />
      <path fill="#86E0C2" d="M283.14 353.31h8.55v-36.7h-8.55z" />
      <path fill="#FE9840" d="M162.85 269.88l-.04-17.18 98.31-.22.04 17.19z" />
      <path
        d="M217.33 255.85l.02 10.64M251.36 255.78l.02 10.63M207.17 255.87l.02 10.64"
        stroke="#FEC391"
        strokeWidth="2"
      />
      <path fill="#00A7DB" d="M150.3 252.63h102.67V238.9H150.3z" />
      <path d="M242.27 244.62v8.01" stroke="#75CFEC" strokeWidth="2" />
      <path
        fill="#75CFEC"
        d="M181.39 248.63h40.5v-5.73h-40.5zM299.25 379.21h8.31v-98.37h-8.31zM.36 379.21h8.31v-98.37H.37z"
      />
      <path
        fill="#3BBAE3"
        d="M0 389.56h307.7V378.8H0zM0 280.62h307.7v-10.76H0z"
      />
      <path
        fill="#75CFEC"
        d="M299.25 269.87h8.31v-73.13h-8.31zM.36 269.87h8.31v-73.13H.37z"
      />
      <path fill="#3BBAE3" d="M0 196.38h307.7v-10.76H0z" />
      <path
        fill="#75CFEC"
        d="M299.25 185.63h8.31V87.25h-8.31zM.36 185.63h8.31V87.25H.37z"
      />
      <path fill="#3BBAE3" d="M0 87.03h307.7V76.28H0z" />
      <path fill="#00A7DB" d="M289.16 87.03H165.93l8.1-10.75h107.03z" />
      <path fill="#FE9840" d="M11.58 99.74l25.59-.03.32 85.66-25.6.04z" />
      <path d="M32.45 176.87l-15.84.02" stroke="#FEC391" strokeWidth="2" />
      <path fill="#FEC391" d="M19.53 162.38h10v-46.59h-10z" />
      <path
        fill="#FE9840"
        d="M237.49 314.58l24.77 6.4-14.68 57.96-24.78-6.4z"
      />
      <path d="M244.2 371.93l-15.35-3.95" stroke="#FEC391" strokeWidth="2" />
      <path fill="#FEC391" d="M243.9 361.4l-9.68-2.5 8.16-31.48 9.68 2.5z" />
      <g>
        <path
          d="M293 55.65C293 74.54 280.45 77 248.63 77 188.9 77 191 75.1 191 56.2c0-18.88 25.8-34.2 57.62-34.2C280.45 22 293 36.75 293 55.65"
          fill="#F6F6F6"
        />
        <path
          d="M293 55.03C293 73.58 280.45 76 248.63 76 188.9 76 191 74.13 191 55.59 191 37.04 216.8 22 248.63 22 280.45 22 293 36.49 293 55.03z"
          stroke="#DADADA"
          strokeWidth="3"
        />
        <path
          d="M264 76.58c-13.46 0-24.37-9.85-24.37-22 0-12.16 10.91-22 24.37-22s18.87 6.95 18.87 7.05"
          fill="#F6F6F6"
        />
        <path
          d="M264 76.58c-13.46 0-24.37-9.85-24.37-22 0-12.16 10.91-22 24.37-22s18.87 6.95 18.87 7.05"
          stroke="#DADADA"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M238.75 117a4.77 4.77 0 0 1-3.85-1.95c-10.08-13.73-11.83-31.35-4.07-41 5.04-6.26 12.91-7.7 21.6-3.95 11.43 4.94 20.27 5.64 26.33 2.18 13.53-7.71 11.2-18.57 13.82-18.27 2.61.27 2.66 19.67-8.93 26.43-8.83 5.15-20.6 4.6-35.02-1.63-4.63-2-8.11-1.6-10.35 1.18-5.4 6.73-2.13 20.66 4.32 29.46a4.74 4.74 0 0 1-3.85 7.55"
          fill="#DADADA"
        />
        <path
          d="M192 75.61c0 3.1-3.8 4.39-8.5 4.39s-8.5-1.29-8.5-4.39c0-3.1 3.8-5.61 8.5-5.61s8.5 2.51 8.5 5.61"
          fill="#F6F6F6"
        />
        <path
          d="M192 75.61c0 3.1-3.8 4.39-8.5 4.39s-8.5-1.29-8.5-4.39c0-3.1 3.8-5.61 8.5-5.61s8.5 2.51 8.5 5.61z"
          stroke="#DADADA"
          strokeWidth="3"
        />
        <path
          d="M211 75.61c0 3.1-3.8 4.39-8.5 4.39s-8.5-1.29-8.5-4.39c0-3.1 3.8-5.61 8.5-5.61s8.5 2.51 8.5 5.61"
          fill="#F6F6F6"
        />
        <path
          d="M211 75.61c0 3.1-3.8 4.39-8.5 4.39s-8.5-1.29-8.5-4.39c0-3.1 3.8-5.61 8.5-5.61s8.5 2.51 8.5 5.61z"
          stroke="#DADADA"
          strokeWidth="3"
        />
        <path
          d="M228.98 12.89a1.67 1.67 0 0 0-2.76-1.47L205.74 29.5a77.17 77.17 0 0 0-12.24-.9c-4.33 0-8.45.28-12.24.9l-20.48-18.08a1.67 1.67 0 0 0-2.76 1.47l3.73 28.77c-.8 2.01-1.25 4.3-1.25 6.9 0 7.62 7.95 14.53 14 19.5 5.96 4.91 9.95 7.94 19 7.94 8.06 0 11.24-2.4 16.97-6.4 7.23-5.03 16.03-12.6 16.03-21.05 0-2.6-.45-4.88-1.25-6.9l3.73-28.76z"
          fill="#F6F6F6"
        />
        <path
          d="M228.98 12.89a1.67 1.67 0 0 0-2.76-1.47L205.74 29.5a77.17 77.17 0 0 0-12.24-.9c-4.33 0-8.45.28-12.24.9l-20.48-18.08a1.67 1.67 0 0 0-2.76 1.47l3.73 28.77c-.8 2.01-1.25 4.3-1.25 6.9 0 7.62 7.95 14.53 14 19.5 5.96 4.91 9.95 7.94 19 7.94 8.06 0 11.24-2.4 16.97-6.4 7.23-5.03 16.03-12.6 16.03-21.05 0-2.6-.45-4.88-1.25-6.9l3.73-28.76z"
          stroke="#DADADA"
          strokeWidth="3"
        />
        <path
          d="M197 68.02c0 2.2-2.68 3.98-4 3.98-1.2 0-4-1.78-4-3.98s1.75-2.02 3.96-2.02c2.2 0 4.04-.18 4.04 2.02"
          fill="#FEAD64"
        />
        <path
          d="M186 70l-24 2M186 68l-26-5M200 70l24 2M200 68l26-5"
          stroke="#B3B3B3"
          strokeLinecap="round"
        />
        <path
          d="M175 57a6.06 6.06 0 0 1 9 0M202 57a6.06 6.06 0 0 1 9 0"
          stroke="#B3B3B3"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
    </g>
  </svg>
);
export default Image;
